<script setup>
import { computed } from 'vue'
import translateIfKey from '@/utils/translateIfKey.js'

const props = defineProps({
  header: {
    required: true,
  },
  content: {
    default: null,
  },
})

// Пусто — только отсутствие значения: раньше `content ? … : '-'` прятал и число 0 (ставка,
// остаток дней). Пустое — приглушённым прочерком, чтобы не спорить с заполненными полями.
const _isEmpty = computed(() =>
  props.content === null || props.content === undefined || props.content === '' || props.content === '-',
)
</script>
<template>
  <div class="text-body mb-1">
    <div class="c-slate-500" style="margin-bottom: 4px">{{ translateIfKey(header) }}</div>
    <slot v-if="$slots.customContent" name="customContent"/>
    <div v-else-if="_isEmpty" class="c-slate-400">—</div>
    <div v-else>{{ content }}</div>
  </div>
</template>
